import { IBingoData } from "../@types/interface.d";

const BINGO_DATA_KEY = "bingoData";
const BINGO_DATA_LENGTH = 20;

class BingoStorage {
  private data: IBingoData[];

  constructor() {
    const str = localStorage.getItem(BINGO_DATA_KEY);
    if (str) {
      this.data = JSON.parse(str) as IBingoData[];
    } else {
      this.data = [];
    }
  }

  public getBingoData(bingoId: string): IBingoData | undefined {
    return this.data.find(v => v.bingoId === bingoId);
  }

  public setBingoData(bingoId: string, memberId: string) {
    if (this.data.length >= BINGO_DATA_LENGTH) {
      this.data.shift();
    }
    this.data.push({
      bingoId,
      memberId,
    });
    localStorage.setItem(BINGO_DATA_KEY, JSON.stringify(this.data));
  }
}

const bingoStorage = new BingoStorage();
export default bingoStorage;
